import React from "react";
import styled from "styled-components";
import { usePublishMessageEvent } from "../hooks/usePublishMessageEvent";
import { Dropdown } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { MicroserviceEventType } from "../types";

const ActionColumnParent = styled.td`
    width: ${({ width }) => width}%;
    cursor: pointer;
    vertical-align: middle;
    text-align: ${(props: any) => props.textAlign ?? "left"};
`;

const ActionColumnParentToggle = React.forwardRef<any>(({ ...rest }, ref) => (
    <div ref={ref} {...rest}>
        <FontAwesomeIcon icon={["fas", "ellipsis"]} />
    </div>
));

export const MicroserviceEventTableActionColumn = ({ width = 2.5, data } : Readonly<{ width?: number, data: MicroserviceEventType }>) => {
    const menuId = React.useId();
    const { publishEvent: publishOutbox } = usePublishMessageEvent();

    const onHandlePublishEvent = () => {
        if (data.type === 0) {
            console.error('does not know how to handle inbox re-syncing just yet..');
        }
        else {
            publishOutbox(data.eventId);
        }
    };

    return (
        <ActionColumnParent width={width}>
            <Dropdown className="caret-off">
                <Dropdown.Toggle id={menuId} as={ActionColumnParentToggle} />
                <Dropdown.Menu style={{ maxWidth: '14rem' }}>
                    <Dropdown.Header>Options</Dropdown.Header>
                    <Dropdown.Item onClick={onHandlePublishEvent}>
                        <FontAwesomeIcon icon={['fas', 'share']} size="sm" className="me-1" />
                        Publish Event
                    </Dropdown.Item>
                </Dropdown.Menu>
            </Dropdown>
        </ActionColumnParent>
    )
};